module.exports = __webpack_public_path__ + "static/media/undraw_share_766i@2x.06d12beb.png";